var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.shoppingList !== null)?_c('AsiPageTitle',{attrs:{"icon":_vm.icons.shoppingList,"title":_vm.shoppingList.name,"loading":_vm.loading}}):_vm._e(),_c('ShoppingListTabDetails',{attrs:{"shopping-list":_vm.shoppingList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }